import { EGradientDirection } from "./enums";
import { useEffect, useState } from 'react';


export const createGradientOrSolid = ({
    colorOne,
    colorTwo,
    gradientDirection,
}: {
    colorOne: string;
    colorTwo?: string;
    gradientDirection?: EGradientDirection;
}) => {
    if (colorOne && (colorTwo === "false" || !colorTwo)) {
        return colorOne;
    }
    if (gradientDirection && !Object.values(EGradientDirection).includes(gradientDirection)){
        gradientDirection = EGradientDirection.BottomToTop;
    }
    return `linear-gradient(${gradientDirection || EGradientDirection.BottomToTop}, ${colorOne}, ${colorTwo})`;
};

export function useUrlQuery(query: string) {
    const queryParameters = new URLSearchParams(window.location.search)
    return queryParameters.get(query);
}

export function useUrlHash(query: string) {
    const queryParameters = new URLSearchParams(window.location.hash)
    return queryParameters.get(query);
}

export function useApplePay() {
    const isApplePayAvailable = (window as any)?.ApplePaySession;
    return { isApplePayAvailable };
}

const formattingCoundown = (values: number[]) => {
    if(values[0] > 0) {
        return `${values[0]}d ${values[1]}h ${values[2]}m ${values[3]}s`;
    }
    else if(values[1] > 0) {
        return `${values[1]}h ${values[2]}m ${values[3]}s`;
    }
    else if(values[2] > 0) {
        return `${values[2]}m ${values[3]}s`;
    }
    else return `${values[3]}s`;
}

const getReturnValues = (countDown: any) => {
    const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000);
  
    return formattingCoundown([days, hours, minutes, seconds]);
};

export function useCountdown(targerDate: number) {

    const [countDown, setCountDown] = useState(
        targerDate- new Date().getTime()
    );

    useEffect(() => {
        const interval = setInterval(() => {
            setCountDown(targerDate - new Date().getTime());
        }, 1000);
    
        return () => clearInterval(interval);
    }, [targerDate]);

    if(countDown < 0) return "Expired";
    return getReturnValues(countDown);
}
